// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"250":"587aacf4","453":"88884686","671":"86cc7dd0"}[chunkId] + ".chunk.js";
};